// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a6d42b20","845":"b96bf4d1"}[chunkId] + ".chunk.js";
};